import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

/** A small label: a streak, a skill tag, "new". */
export function Badge(props: {
  tone?: "accent" | "good" | "gentle" | "info" | "sun";
  icon?: IconName;
  children: ReactNode;
}) {
  return (
    <span className="ui-badge" data-tone={props.tone ?? "accent"}>
      {props.icon !== undefined && <Icon name={props.icon} size={16} />}
      {props.children}
    </span>
  );
}
